import { createSelector } from '@ngrx/store';
import { collectionTypeState } from '../root';

export const getCollectionType = createSelector(collectionTypeState, (collectionType) => collectionType);
